import React from 'react'
import LazyLoad from 'react-lazyload'
import { Link } from 'react-router-dom'
const Campuscare = () => {
  return (
     <>
      <div className="campuslogo">
         <Link to="https://www.mgmbcampuscare.in/" target="_blank">
            <LazyLoad><img src="https://webapi.entab.info/api/image/MGMB/public/Images/Campulogo.png" className="img-fluid float-end campus" alt="MGM bokaro"/></LazyLoad>
            </Link>
      </div>
      </>
        
  )
}

export default Campuscare
